import { render, staticRenderFns } from "./BudgetAnalysis.vue?vue&type=template&id=7a442354"
import script from "./BudgetAnalysis.vue?vue&type=script&lang=js"
export * from "./BudgetAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports